import { apiClient } from "@/lib/api"

export interface CurrencyRate {
  id: number
  currency_code: string
  rate_date: string
  rate_to_eur: number
  source: string
  created_at: string
  updated_at?: string | null
}

export interface CurrencyRateQuery {
  currency_code?: string
  rate_date?: string
}

export interface ManualCurrencyRatePayload {
  currency_code: string
  rate_date: string
  rate_to_eur: number
}

export async function fetchCurrencyRates(query: CurrencyRateQuery = {}): Promise<CurrencyRate[]> {
  const searchParams = new URLSearchParams()

  if (query.currency_code) {
    searchParams.set("currency_code", query.currency_code)
  }

  if (query.rate_date) {
    searchParams.set("rate_date", query.rate_date)
  }

  const queryString = searchParams.toString()
  const url = `/currency/rates${queryString ? `?${queryString}` : ""}`

  return apiClient.get<CurrencyRate[]>(url)
}

export async function createManualCurrencyRate(payload: ManualCurrencyRatePayload): Promise<CurrencyRate> {
  return apiClient.post<CurrencyRate>("/currency/rates/manual", payload)
}

export interface CurrencyRateOverrideResponse {
  message: string
  override_rate: string
  original_shared_rate: string | null
}

export async function setInvoiceCurrencyRateOverride(
  invoiceId: string,
  rateValue: number
): Promise<CurrencyRateOverrideResponse> {
  return await apiClient.patch<CurrencyRateOverrideResponse>(
    `/invoices/${invoiceId}/currency-rate-override?rate_value=${rateValue}`,
    null
  )
}

export async function clearInvoiceCurrencyRateOverride(
  invoiceId: string
): Promise<{ message: string }> {
  return await apiClient.delete<{ message: string }>(
    `/invoices/${invoiceId}/currency-rate-override`
  )
}

export interface SetActiveCurrencyResponse {
  active_currency_code: string
  currency_representations: import("@/screens/SaldoReview/sections/InvoiceReviewSection/types").CurrencyRepresentation[]
}

export async function setInvoiceActiveCurrency(
  invoiceId: string,
  currencyCode: string
): Promise<SetActiveCurrencyResponse> {
  return await apiClient.patch<SetActiveCurrencyResponse>(
    `/invoices/${invoiceId}/active-currency?currency_code=${encodeURIComponent(currencyCode)}`,
    null
  )
}
